import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CampaignDetails = lazy(() =>
  import("@campaigns/CampaignDetails").then((module) => ({ default: module.CampaignDetails }))
);

export const surveysHubCampaignDetailsNRO: NavigationRoutingObject = {
  Component: CampaignDetails,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("surveys-sidebar-pill-menu-option", "Surveys"),
  pageNameForTracking: () => "Surveys Hub - Campaign",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("surveys-sidebar-pill-menu-option-description", "View surveys across landing pages, campaigns, and Canvas"),
  icon: "nav-system-surveys",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("surveys_hub_detail_page") &&
      featureOn("surveys_hub") &&
      featureOn("iam_surveys") &&
      hasPermission("appGroup", { permission: "viewCampaigns" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  showInSearchResults: false,
  defaultRoute: "/engagement/surveys/:appGroupId",
};
